import { List, Datagrid, TextField, useRecordContext } from 'react-admin';
import { useParams } from 'react-router-dom';
import { Button,Link} from '@mui/material';
import PostIcon from '@mui/icons-material/Book';
import UserIcon from '@mui/icons-material/People';
export const CategoryList = (props) => {
    return (
        <List {...props}>
            <Datagrid rowClick="show">
                <TextField source="id" />
                <TextField source="name" />
                {/* <TextField source="definition" /> */}
                {/* <TextField source="recordCompany" label="Label" /> */}
                {/* <EditPromptButton /> */}
            </Datagrid>
        </List>
    );
};

// const EditPromptButton = () => {
//     const song = useRecordContext();
//     return (
//         <Button
//             component={Link}
//             to={`/artists/${song?.artist_id}/songs/${song?.id}`}
//             startIcon={<EditIcon />}
//         >
//             Edit
//         </Button>
//     );
// };